import {closest, selection, range} from '@/components/js/Utils.js'

export default class EditorSetting {
  static TYPE_TEXT = 'text'
  static TYPE_LINE = 'hr'
  static TYPE_POINT = 'point'
  static TYPE_IMG = 'img'
  static TYPE_BLOCK = 'block'
  static TYPE_TITLE = 'title'
  static TYPE_INDEX = 'index'
  static TYPE_FOOTNOTE = 'footnote'
  static TYPE_SECTION = 'section'

  static ALIGN_LEFT = 'left'
  static ALIGN_RIGHT = 'right'
  static ALIGN_CENTER = 'center'
  static ALIGN_JUSTIFY = 'justify'
  static SIZE_LARGE = 'large'
  static SIZE_MIDDLE = 'middle'
  static SIZE_SMALL = 'small'
  static STYLE_SOLID = 'solid'
  static STYLE_INSET = 'inset'
  static STYLE_DOUBLE = 'double'
  static STYLE_DASHED = 'dashed'
  static STYLE_FULL = 'fullImage'
  static STYLE_ORG = 'orgImage'
  static STYLE_BLOCK01 = 'mark_01'
  static STYLE_BLOCK02 = 'mark_02'
  static STYLE_BLOCK03 = 'mark_03'
  static STYLE_BLOCK04 = 'mark_04'

  static _enter = 'P'
  static _block = 'blockquote'
  static _img = '.img'
  static _line = '.line'
  static _section = '.sectionline'
  static _select = '.select'
  static _index = '.u_index'
  static _pointline = '.pointline'

  static get ENTER () { return this._enter }
  static get BLOCK () { return this._block }
  static get IMG () { return this._img }
  static get toIMG () { return this._img.split('.')[1] }
  static get LINE () { return this._line }
  static get toLINE () { return this._line.split('.')[1] }
  static get POINTLINE () { return this._pointline }
  static get toPOINTLINE () { return this._pointline.split('.')[1] }
  static get SECTION () { return this._section }
  static get toSECTION () { return this._section.split('.')[1] }
  static get INDEX () { return this._index }
  static get toINDEX () { return this._index.split('.')[1] }

  static get SELECT () { return this._select }
  static get toSELECT () { return this._select.split('.')[1] }

  static get toSTRIKE () { return 'strikethrough' }

  static get toolTYPE () { return 'type' }
  static get toolFONT () { return 'fontName' }
  static get toolBOLD () { return 'bold' }
  static get toolITALIC () { return 'italic' }
  static get toolUNDERLINE () { return 'underline' }
  static get toolSTRIKE () { return 'strikeThrough' }
  static get toolLINE () { return 'insertHorizontalRule' }
  static get toolIMG () { return 'insertImage' }
  static get toolBLOCK () { return 'formatBlock' }
  static get toolAlign () { return 'align' }
  static get toolSize () { return 'size' }
  static get toolStyle () { return 'style' }
  static get toolForeCOLOR () { return 'foreColor' }
  static get toolBackCOLOR () { return 'backColor' }
  static get toolLINK () { return 'createLink' }
  static get toolINDENT () { return 'indent' }
  static get toolREMOVE () { return 'delete' }
  static get toolLASTENTER () { return 'lastenter' }

  static get toolFOOTNOTE () { return 'footnote' }
  static get toolSECTION () { return 'section' }

  static get KEYDOWN () { return 'edit_keydown' }
  static get SELECTION () { return 'edit_selection' }
  static get MOUSEDOWN () { return 'edit_mousedown' }
  static get COPY () { return 'edit_copy' }
  static get CUT () { return 'edit_cut' }
  static get PASTE () { return 'edit_paste' }
  static get REMOVE () { return 'edit_remove' }
  static get REMOVE_END () { return 'edit_remove_end' }
  static get DRAGSTART () { return 'edit_dragstart' }

  get selection () {
    return selection()
  }

  get range () {
    return range()
  }

  static get isCollapsed () {
    var s = selection()
    if (s.isCollapsed && s.anchorOffset === s.extentOffset) {
      return true
    } else if (closest(s.anchorNode, EditorSetting.SELECT)) {
      return true
    }
    return false
  }

  static getRangeTarget (r) {
    var tlist = ['.u_textEdit', EditorSetting.ENTER, EditorSetting.BLOCK, EditorSetting.INDEX, EditorSetting.LINE, EditorSetting.IMG, EditorSetting.SECTION]
    var sn = closest(r.startContainer, tlist)
    var en = closest(r.endContainer, tlist)
    console.log(sn, en)
    if (sn.id === 'u_textEdit') {
      sn = sn.firstChild
    }
    if (en.id === 'u_textEdit') {
      en = en.firstChild
    }
    return {start: sn, end: en}
  }

  static hasSelection (focus, checkNode, checkOne) {
    // console.log(focus instanceof Range)
    if (focus instanceof Range) {
      // console.log('focus', focus.toString())
    } else {
      if (focus instanceof Function) {
        checkOne = checkNode
        checkNode = focus
        focus = range()
      } else {
        focus = range()
      }
    }
    var s = selection()
    // console.log('hasSelection', s, focus.startContainer)
    var tlist = ['.u_textEdit', EditorSetting.ENTER, EditorSetting.BLOCK, EditorSetting.INDEX]
    console.log(s.anchorOffset, s.extentOffset)
    console.log(closest(s.anchorNode, '.u_textEdit').outerHTML.indexOf(s.anchorNode.nodeValue), closest(s.anchorNode, '.u_textEdit').outerHTML.indexOf(s.extentNode.nodeValue))
    var si = closest(s.anchorNode, '.u_textEdit').outerHTML.indexOf(s.anchorNode.nodeValue)
    var ei = closest(s.anchorNode, '.u_textEdit').outerHTML.indexOf(s.extentNode.nodeValue)
    var sn = closest(s.anchorNode, tlist)
    var en = closest(s.extentNode, tlist)
    if (si > ei) {
      var temp = en
      en = sn
      sn = temp
    }
    // console.log(sn, en)
    if (sn.id === 'u_textEdit') {
      sn = sn.firstChild
    }
    if (en.id === 'u_textEdit') {
      en = en.firstChild
    }
    var dump = []
    var item
    if (sn && en) {
      item = checkOne(sn)
      if (item) {
        dump.push(item)
      }
      item = checkOne(s.anchorNode)
      if (item) {
        dump.push(item)
      }
      var t = sn
      while (true) {
        checkNode(s, t, dump)
        if (t === en) {
          break
        } else {
          console.log(t)
          t = t.nextSibling
          if (t === null) {
            break
          }
        }
      }
      // console.log(s.anchorNode, s.extentNode, s.anchorNode !== s.extentNode)
      if (s.anchorNode !== s.extentNode) {
        item = checkOne(en)
      }
      if (item) {
        dump.push(item)
      }
      if (s.anchorNode !== s.extentNode) {
        item = checkOne(s.extentNode)
      }
      if (item) {
        dump.push(item)
      }
    }
    return [...new Set(dump)]
  }
}



// WEBPACK FOOTER //
// ./src/components/js/EditorSetting.js